import React, {useState} from "react";
import "./DialogsStyle.sass"
import cactus from "../../img/profileImg/dialogs/cactus.png"
import pk from "../../img/profileImg/dialogs/pk.png"
import coct from "../../img/profileImg/dialogs/coct.png"
import lampa from "../../img/profileImg/dialogs/lampa.png"
import joystick from "../../img/profileImg/dialogs/joystick.png"
import FormDialogs from "./FormDialogs/FormDialogs";
import DialogsUsers from "./Dialogs-user/DialogsUser";
import DialogsMessages from "./Dialogs-messages/DialogsMessages";
import empty from "../../img/profileImg/dialogs/empty.png";
import exit from "../../img/dialogs/exit.png";

const Dialogs = (props) => {

    let exitOnInterlocutors = (showMessages, showInterlocutors) => {
        setShowMessages(showMessages);
        setShowInterlocutors(showInterlocutors)
    };

    let [showMessages, setShowMessages] = useState(window.innerWidth >= 500);

    let [ShowInterlocutors, setShowInterlocutors] = useState(true);

    let usersMessage = props.usersMessage.map(user => <DialogsUsers img={user.img}
                                                                    name={user.name}
                                                                    key={user.id}
                                                                    correspondence={props.correspondence}
                                                                    id={user.id}
                                                                    activeUser={props.activeUser}
                                                                    setShowMessages={setShowMessages}
                                                                    exitOnInterlocutors={exitOnInterlocutors}/>);
    let message = 0;

    if (props.messages.length !== 0)
        message = props.messages.map(message => <DialogsMessages key={message.id} id={message.id} text={message.text} sender={message.sender} users={props.usersMessage}/>);

    let onSubmit = (object) => {
        props.sendMessage(object.dialog)
    };

    return (

        <section className='dialogs main-bg'>
            <div className="dialogs__bg-header">
                <div className="dialogs__header">
                    <div className='dialogs__title title'>
                        <h1>Ваши сообщения</h1>
                        <h3>Добро пожаловать в ваши сообщения, здесь вы будете видеть смешные,
                            грустные, тупые или прекраснецшие сообщения от ваших друзей(ну или не друзей, как повезет)
                        </h3>
                    </div>
                    <div className="dialogs__subtitle">
                        <div><img src={cactus} alt=""/></div>
                        <div><img src={coct} alt=""/></div>
                        <div><img src={pk} alt=""/></div>
                        <div><img src={lampa} alt=""/></div>
                        <div><img src={joystick} alt=""/></div>
                    </div>
                </div>
            </div>
            <div className="dialogs__container container side-card">
                {ShowInterlocutors ? <li className="dialogs__interlocutors">{usersMessage}</li> : null}
                {showMessages ? <div className="dialogs__window-messages">
                    <div className="dialogs__exit"><img src={exit} alt="" onClick={() => exitOnInterlocutors(false, true)}/></div>
                    <div className="dialogs__window-messages-container">
                        <div className="dialogs__all-messages">
                            {props.messages.length !== 0 ? message :
                                <div className='dialogs__empty-message'>
                                    <div><img src={empty} alt=""/></div>
                                </div>
                            }
                        </div>
                        <FormDialogs onSubmit={onSubmit}/>
                    </div>
                </div> : null}
            </div>
        </section>
    )
};

export default Dialogs